import { Delete, ExitToApp, NoteAdd, Print, Save } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DialogCancel from '../../../../../components/utils/dialogCancel/dialogCancel';
const CustomerInfo = ({data, postData, setPostData , setData ,}) => {
  const dispatch = useDispatch()
   const [dialogClose, setDialogClose] = useState(false);
 
  const navigate = useNavigate()
   const totalWithRetQty = data.reduce((acc, item) => {
    if (item.retQty > 0) {
      return acc + parseFloat(item.rate);
    }
    return acc;
  }, 0);
  
  const gstWithRetQty = data.reduce((acc, item) => {
    if (item.retQty > 0) {
      return acc + parseFloat(item.gst_amt);
    }
    return acc;
  }, 0);
  
  const cessWithRetQty = data.reduce((acc, item) => {
    if (item.retQty > 0) {
      return acc + parseFloat(item.cess_amt);
    }
    return acc;
  }, 0);
  
  // let grandTotal= totalWithRetQty + gstWithRetQty + cessWithRetQty
  let grandTotal= totalWithRetQty + gstWithRetQty 
  let discountamt = data.reduce(
    // (accumulator, item) => accumulator + (parseFloat(item.rate1 || 0) + parseFloat(item.gstAmt || 0) - parseFloat(item.disc1))* item.qty,
    // 0
    (accumulator, item) => accumulator + (parseFloat(item.dis_per || 0) * parseFloat(item.rate || 0)  / 100)* item.retQty,
    0
  );
  console.log(discountamt,"discountamt");
  const onClickCancel = () => {
    setDialogClose(false);
  };
  const onClickExit = () => {
    navigate("/");
  };
  // console.log(paymentDetails)
  const handleExit = () => {
    setDialogClose(true);
  };
    const Design = ({ title, value }) => (
      <div className="flex items-center">
        <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
          {title}
        </Typography>
        <Typography
          variant="h6"
          textAlign="right"
          sx={{
            fontWeight: 600,
            width: "100%",
            padding: 0.5,
          }}
        >
               {parseFloat(value).toFixed(0)}
        </Typography>
      </div>
    );
    useEffect(() => {
      setPostData((prevState)=>({...prevState,amount : parseFloat(Math.round(grandTotal).toFixed(0)),gst_amt: gstWithRetQty, cess_amt : cessWithRetQty,subtotal_amount:totalWithRetQty,roff:parseFloat(grandTotal - Math.round(grandTotal)).toFixed(0),
        discount_amount: discountamt
      }))
    },[data,])

    function handleSubmit(){
      if(postData.partyName === "" ){
        dispatch(setSnackbar(true , "error" , "Please fill party name"))
      }else if( grandTotal === 0){
        dispatch(setSnackbar(true , "error" , "Please enter return qty "))
      }
      else if(postData.outlet_sales_return_details.length > 0 && grandTotal !== 0){
        axios.post(`/v1/outlet_sales_return_master`,postData)
        .then((res) => {
          dispatch(setSnackbar(true,'success','sales Return successfully processed!'))
          setTimeout(()=>{
            window.location.reload();
          },1000)
          })
      .catch((err) => {
        dispatch(setSnackbar(true , "error" , err.response.data.errors[0].message))
        })
      }
    }

    return (
  <Fragment>
  
  <Typography
          variant="h6"
          textAlign="center"
          mb={2}
          sx={{ backgroundColor: "#83A2FF" }}
        >
          Total
        </Typography>
      <div className="flex p-1">
  
            <Typography
            className=' '
            textAlign="right" sx={{  paddingRight: 0.4, fontWeight: 600, fontSize: 36}}          >
             {Math.round(grandTotal).toFixed(0)}
            </Typography>
          </div>
          <div className="my-2">
        <Typography
          variant="h6"
          textAlign="center"
          mb={2}
          sx={{ backgroundColor: "#83A2FF" }}
        >
          Summary
        </Typography>
        <Design title="Sub Total" value={totalWithRetQty} />
            <Design title="GST Amt" value={gstWithRetQty}/>
            {/* <Design title="Cess" value={cessWithRetQty}/> */}
            <Design title="Round Off" value={(grandTotal - Math.round(grandTotal).toFixed(0))}/>
            <Design title="Net Total" value={Math.round(grandTotal)}/>
      </div>
      <Stack  >
              {/* <Grid item xs={6}> */}
              {/* <Button size="small" sx={{margin:1}} startIcon={<Delete/>} variant="outlined" onClick={handleDelete} >Delete</Button>
              <Button size="small" sx={{margin:1}} startIcon={<Print/>} variant="outlined">Print</Button> */}
              {/* </Grid> */}
              {/* <Grid item xs={6}> */}
              <Button size="small" sx={{margin:1}} startIcon={<NoteAdd/>} variant="outlined" onClick={()=>  window.location.reload()}>New</Button>
              <Button size="small" sx={{margin:1}} startIcon={<Save/>} variant="outlined" onClick={handleSubmit}>Save</Button>
              <Button size="small" sx={{margin:1}} startIcon={<ExitToApp />} variant="outlined" onClick={handleExit}>Exit</Button>
              {/* </Grid> */}
              </Stack>
              <DialogCancel
        onClickCancel={onClickCancel}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose={setDialogClose}
      />
  </Fragment>
  )
}

export default memo(CustomerInfo)